import { render, staticRenderFns } from "./CertificateDetail.vue?vue&type=template&id=27f7858a&scoped=true&"
import script from "./CertificateDetail.vue?vue&type=script&lang=js&"
export * from "./CertificateDetail.vue?vue&type=script&lang=js&"
import style0 from "./CertificateDetail.vue?vue&type=style&index=0&id=27f7858a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f7858a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VDivider,VIcon,VProgressCircular})
